import React from 'react';
import { Router, Switch } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import PrivateRoute from './PrivateRoute';

export const history = createBrowserHistory();

const AppRouter = (props) => {
  let privateRoutes = [];
  props.items.map((item, i) => {
    privateRoutes.push(
      <PrivateRoute key={i} path={item.path} component={item.component} exact />
    );
  });
  return (
    <Router history={history}>
      <div className="general-full-height">
        <Switch>{privateRoutes}</Switch>
      </div>
    </Router>
  );
};

export default AppRouter;
